export default __webpack_public_path__ + "static/lsnifa-logo-white-dec71f79cb9af36e68c1124e39698c30.svg";